import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { observer } from 'mobx-react';
import React, { ReactNode } from 'react';

interface IPropsModal {
    aberto: boolean;
    fecharModal: (() => any) | ((event, reason) => any)
    outrasAcoes?: ReactNode;
    funcaoAcaoPrimaria?: ((any) => any) | ((event, reason) => any);
    labelAcaoPrimaria?: string;
    funcaoAcaoSecundaria?: ((any) => any) | ((event, reason) => any);
    acaoPrimariaDisabled?: boolean;
    labelAcaoSecundaria?: string;
    acaoSecundariaDisabled?: boolean;
    titulo: string | ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    fullWidth?: boolean;
    PaperProps?: any;
    dialogContentStyle?: any;
    dialogActionsStyle?: any;
    apenasAcaoPrimaria?: boolean;
    texto?: string;
    fontBoldTitulo?: string;
    children?: ReactNode;
    disableRestoreFocus?: boolean;
}




class Modal extends React.Component<IPropsModal> {
    private temTitulo = (): boolean => {
        const { titulo } = this.props;
        if (titulo === undefined || titulo === null) {
            return false;
        }
        if (typeof titulo === 'string') {
            return titulo.trim().length > 0;
        }
        return true;
    }

    renderBotoes() {
        return (
            <span>
                {this.props.funcaoAcaoPrimaria &&
                    <Button style={{ marginRight: '5px' }} variant='contained'
                        color='primary' onClick={this.props.funcaoAcaoPrimaria as React.MouseEventHandler<HTMLButtonElement>} disabled={this.props.acaoPrimariaDisabled}>
                        {this.props.labelAcaoPrimaria}
                    </Button>
                }
                {!this.props.apenasAcaoPrimaria &&
                    <Button variant='outlined' color='secondary' onClick={(event) => this.props.funcaoAcaoSecundaria(event, null)} disabled={this.props.acaoSecundariaDisabled}>
                        {this.props.labelAcaoSecundaria}
                    </Button>
                }
            </span>
        )
    }

    render() {
        return (
            <Dialog open={this.props.aberto} onClose={this.props.fecharModal} maxWidth={this.props.maxWidth}
                fullWidth={this.props.fullWidth} PaperProps={this.props.PaperProps}
                disableRestoreFocus={this.props.disableRestoreFocus}
            >
                {this.temTitulo() ? <DialogTitle sx={{ fontWeight: this.props.fontBoldTitulo || 'normal' }}>{this.props.titulo}</DialogTitle> : null}
                <DialogContent style={this.props.dialogContentStyle || { overflowY: 'auto' }}>
                    {this.props.children}
                </DialogContent>
                <DialogActions style={this.props.dialogActionsStyle || { paddingBottom: '15px', paddingTop: '15px' }}>
                    <div style={{ color: 'red', fontSize: 'small', marginLeft: '20px' }}>
                        <b>
                            {this.props.texto}
                        </b>
                    </div>
                    {this.props.outrasAcoes}
                    {this.props.texto?.length ?
                        <div style={{ width: '50%', display: 'flex', justifyContent: 'end' }}>
                            {this.renderBotoes()}
                        </div>
                        :
                        this.renderBotoes()
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default observer(Modal);
